import { Injectable } from '@angular/core';
import { Occ } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CategoryConnector } from '../data-bindings/category/category.connector';
import Category = Occ.Category;

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  constructor(protected categoryConnector: CategoryConnector) {}

  getCategory(categoryId: string): Observable<Category | undefined> {
    return this.categoryConnector.get('ggProductCatalog', 'Online', categoryId);
  }
}
